// English translations
const en = {
  "common": {
    "loading": "Loading...",
    "error": "Error",
    "success": "Success",
    "cancel": "Cancel",
    "save": "Save",
    "delete": "Delete",
    "edit": "Edit",
    "add": "Add",
    "create": "Create",
    "search": "Search",
    "filter": "Filter",
    "export": "Export",
    "import": "Import",
    "close": "Close",
    "confirm": "Confirm",
    "yes": "Yes",
    "no": "No",
    "all": "All",
    "active": "Active",
    "inactive": "Inactive",
    "today": "Today",
    "week": "This week",
    "month": "This month",
    "lastMonth": "Last month",
    "year": "This year",
    "customDateRange": "Date range",
    "date": "Date",
    "type": "Type",
    "amount": "Amount",
    "status": "Status",
    "actions": "Actions",
    "name": "Name",
    "email": "Email",
    "phone": "Phone",
    "location": "Location",
    "bamako": "Bamako",
    "dubai": "Dubai",
    "buy": "Buy",
    "sell": "Sell",
    "wait": "Wait",
    "details": "Details",
    "receipt": "Receipt",
    "whatsapp": "WhatsApp",
    "exportPdf": "Export to PDF",
    "exportExcel": "Export to Excel",
    "update": "Update",
    "register": "Register",
    "submit": "Submit",
    "back": "Back",
    "next": "Next",
    "previous": "Previous",
    "total": "Total",
    "average": "Average",
    "minimum": "Minimum",
    "maximum": "Maximum",
    "opened": "Open",
    "closed": "Closed",
    "raw": "Raw",
    "refined": "Refined",
    "theoretical": "Theoretical",
    "real": "Real",
    "difference": "Difference",
    "alert": "Alert",
    "noData": "No data available",
    "loadingData": "Loading data...",
    "noResults": "No results found",
    "locale": "en-US"
  },
  "navigation": {
    "home": "Home",
    "dashboard": "Dashboard",
    "transaction": "Transaction",
    "transactions": "History",
    "positions": "Positions",
    "stock": "Stock",
    "margins": "Margins",
    "reports": "Reports",
    "swift": "SWIFT",
    "admin": "Admin",
    "profile": "Profile",
    "settings": "Settings",
    "logout": "Logout",
    "login": "Login"
  },
  "landing": {
    "title": "Golden Mali SARL",
    "subtitle": "SaaS Platform - Professional Gold Management",
    "description": "Complete SaaS platform for tracking, estimating, and optimizing your gold and precious metals flows. Online access 24/7 with automatic synchronization and secure cloud backup.",
    "cta": {
      "dashboard": "Access Dashboard",
      "transaction": "New Transaction"
    },
    "hero": {
      "title": "Golden Mali SARL",
      "subtitle": "SaaS Platform - Professional Gold Management",
      "description": "Complete management system for tracking, estimating, and optimizing your gold and precious metals flows. Web access available for updates, data transfers, and synchronization between your devices.",
      "loginButton": "Sign in to access",
      "carousel": {
        "image1": {
          "title": "Financial Charts",
          "subtitle": "Market Analysis - Upward Trends"
        },
        "image2": {
          "title": "Professional Trading",
          "subtitle": "Real-Time Tracking - Informed Decisions"
        },
        "image3": {
          "title": "Performance Analysis",
          "subtitle": "Data Bars - Continuous Evolution"
        },
        "image4": {
          "title": "Modern Interface",
          "subtitle": "Advanced Technology - Interactive Management"
        },
        "image5": {
          "title": "Growth & Expansion",
          "subtitle": "Financial Flows - Return Optimization"
        }
      },
      "loginLink": "Login"
    },
    "restricted": {
      "title": "Restricted Access",
      "description": "This platform is reserved for authorized users.",
      "mustRequest": "You must request access from the platform owner",
      "howToGet": "How to get access?",
      "step1": "Contact the platform owner or administrator",
      "step2": "Request the creation of a user account",
      "step3": "Receive your login credentials by email",
      "step4": "Sign in with your credentials to access the platform",
      "alreadyHave": "I already have access - Sign in",
      "mobileStores": {
        "title": "Mobile applications",
        "subtitle": "Golden Mali will be available soon on Google Play and the App Store.",
        "comingSoon": "Coming soon",
        "scanHint": "Scan to open the store (launch coming soon)",
        "qrAlt": "Golden Mali {{platform}} QR code",
        "directLink": "Store link:",
        "androidTitle": "Android application",
        "androidDescription": "Manage your gold operations from Android, synced in real time with the web platform.",
        "iosTitle": "iOS application",
        "iosDescription": "The same power as the web on iPhone and iPad — coming soon on the App Store.",
        "playStoreButton": "Google Play Store",
        "appStoreButton": "Apple App Store"
      }
    },
    "features": {
      "title": "Main Features",
      "subtitle": "Discover the main features of our professional gold management platform",
      "dashboard": {
        "title": "Decision Dashboard",
        "description": "Real-time overview with buy/sell recommendations based on current margins."
      },
      "transactions": {
        "title": "Transaction Management",
        "description": "Ultra-fast transaction recording with complete tracking and detailed history."
      },
      "positions": {
        "title": "Open Positions",
        "description": "Real-time position tracking with automatic margin and potential profit calculations."
      },
      "stock": {
        "title": "Physical Stock",
        "description": "Stock management by location with alerts and real-time inventory."
      },
      "margins": {
        "title": "Margins & Profits",
        "description": "Clear view of realized margins with trend charts and forecasts."
      },
      "history": {
        "title": "Complete History",
        "description": "Advanced search and PDF/Excel export for your reports and accounting analysis."
      }
    },
    "security": {
      "title": "Security & Privacy",
      "dataSecure": {
        "title": "Secured Data",
        "description": "Protection of sensitive data with mandatory authentication"
      },
      "accessControlled": {
        "title": "Controlled Access",
        "description": "Access management by administrator role and permissions"
      },
      "cloudSync": {
        "title": "Cloud Synchronization",
        "description": "Automatic backup and real-time synchronization"
      },
      "availability": {
        "title": "24/7 Availability",
        "description": "Web access available at any time from any device"
      }
    }
  },
  "login": {
    "title": "Golden Mali SARL",
    "subtitle": "SaaS Platform - Login",
    "email": "Email or Username",
    "password": "Password",
    "submit": "Sign in",
    "submitting": "Signing in...",
    "error": "Login error",
    "version": "Version 1.0 - Golden Mali SARL"
  },
  "dashboard": {
    "title": "Decision Dashboard",
    "personalize": "Customize",
    "editMode": "Edit mode",
    "exitEditMode": "Finish",
    "widgets": {
      "decision": {
        "title": "Recommendation",
        "buy": "BUY",
        "sell": "SELL",
        "wait": "WAIT"
      },
      "goldPrice": {
        "title": "Gold Price",
        "current": "Current price",
        "change": "Change"
      },
      "margin": {
        "title": "Current Margin",
        "current": "Current margin"
      },
      "profit": {
        "title": "Potential Profit",
        "potential": "Potential profit"
      },
      "priceChart": {
        "title": "Price Evolution",
        "price": "Price"
      }
    },
    "loading": "Loading dashboard...",
    "noData": "No data available"
  },
  "home": {
    "features": {
      "title": "Main Features",
      "subtitle": "Discover the powerful tools that will allow you to efficiently manage your gold and precious metals operations",
      "dashboard": {
        "title": "Decision Dashboard",
        "description": "Real-time overview with buy/sell recommendations based on current margins. Interactive charts and key performance indicators for informed decision-making.",
        "access": "Access Decision Dashboard"
      },
      "transactions": {
        "title": "Transaction Management",
        "description": "Ultra-fast transaction recording in 30 seconds. Complete flow tracking with detailed history and advanced search for total traceability.",
        "access": "Access Transaction Management"
      },
      "positions": {
        "title": "Open Positions",
        "description": "Real-time tracking of open positions with automatic margin and potential profit calculations. Smart alerts and notifications to optimize your decisions.",
        "access": "Access Open Positions"
      },
      "stock": {
        "title": "Physical Stock",
        "description": "Stock management by location (Bamako/Dubai) with theoretical/real difference alerts. Real-time inventory and detailed reports for optimal control.",
        "access": "Access Physical Stock"
      },
      "history": {
        "title": "Complete History",
        "description": "Advanced search and multiple filters to analyze all your past transactions. PDF and Excel export for your reports and accounting analysis.",
        "access": "Access Complete History"
      },
      "margins": {
        "title": "Margins & Profits",
        "description": "Clear view of realized margins and profits with monthly evolution. Trend charts and forecasts based on historical data to maximize your returns.",
        "access": "Access Margins & Profits"
      }
    },
    "architecture": {
      "title": "Architecture & Access",
      "subtitle": "SaaS platform accessible online with real-time synchronization and automatic backup",
      "cloud": {
        "title": "Cloud Access & Synchronization",
        "description": "SaaS platform accessible from any internet-connected device. Automatic real-time synchronization of all your data between your different devices."
      },
      "availability": {
        "title": "24/7 Availability",
        "description": "Permanent access to your platform from anywhere in the world. Guaranteed availability 24/7 for continuous management of your operations."
      },
      "traceability": {
        "title": "Traceability & Reports",
        "description": "Track every transaction with a complete history. Generate PDF and Excel reports for your analysis and accounting needs."
      },
      "security": {
        "title": "Security & Reliability",
        "item1": "Encryption of sensitive data",
        "item2": "Automatic local backup",
        "item3": "Automatic cloud backup",
        "item4": "Secure transfers via web access",
        "discover": "Discover the ERP"
      }
    },
    "cta": {
      "title": "Ready to Optimize Your Gold Flows?",
      "description": "Access your dashboard now to make the best decisions based on accurate data and real-time analysis.",
      "subdescription": "Start today and transform your gold and precious metals management.",
      "dashboard": "Access Dashboard",
      "transaction": "Create a Transaction"
    }
  },
  "transactions": {
    "title": "Transaction History",
    "advancedSearch": "Advanced Search",
    "searchType": "Search type",
    "searchPlaceholder": "Enter your search...",
    "searchTypes": {
      "transactionId": "Transaction number",
      "name": "Name",
      "surname": "First name",
      "amount": "Amount",
      "idNumber": "ID number"
    },
    "status": "Status",
    "allStatus": "All",
    "closed": "Closed",
    "open": "Open Positions",
    "period": "Period",
    "allPeriod": "All",
    "today": "Today",
    "week": "This week",
    "month": "This month",
    "lastMonth": "Last month",
    "customDateRange": "Date range",
    "startDate": "Start date",
    "endDate": "End date",
    "counter": "Counter",
    "allCounters": "All counters",
    "partner": "Partner",
    "allPartners": "All partners",
    "table": {
      "txNumber": "TX Number",
      "date": "Date",
      "type": "Type",
      "amount": "Amount",
      "counter": "Counter",
      "partner": "Partner",
      "margin": "Margin",
      "status": "Status",
      "actions": "Actions"
    },
    "loading": "Loading transactions...",
    "noTransactions": "No transactions found",
    "details": {
      "title": "Transaction Details",
      "generalInfo": "General Information",
      "date": "Date",
      "type": "Type",
      "amount": "Amount",
      "counter": "Counter",
      "partner": "Partner",
      "margin": "Margin",
      "status": "Status",
      "history": "Modification History",
      "noHistory": "No modifications recorded for this transaction",
      "field": "Modification",
      "action": {
        "create": "Creation",
        "update": "Update",
        "delete": "Deletion",
        "other": "Action"
      },
      "user": "Unknown user",
      "oldValue": "Old value:",
      "newValue": "New value:",
      "close": "Close"
    },
    "export": {
      "pdf": "Export to PDF",
      "excel": "Export to Excel",
      "title": "Transaction History",
      "exported": "Exported on:",
      "headers": {
        "txNumber": "TX Num",
        "date": "Date",
        "type": "Type",
        "amount": "Amount",
        "counter": "Counter",
        "partner": "Partner",
        "margin": "Margin",
        "status": "Status"
      },
      "total": "Total: {count} transaction(s)"
    }
  },
  "transactionForm": {
    "title": "New Transaction",
    "txNumber": "Transaction Number",
    "type": "Transaction Type",
    "buy": "BUY",
    "sell": "SELL",
    "amount": "Amount",
    "currency": "Currency",
    "counter": "Counter",
    "bamako": "BAMAKO",
    "dubai": "DUBAI",
    "goldDetails": {
      "title": "Gold Details (Optional)",
      "executablePrice": "Executable Gold Price (USD/oz)",
      "executablePricePlaceholder": "Price actually used",
      "caratGross": "Gross Carat",
      "caratGrossPlaceholder": "Ex: 22",
      "weightGross": "Gross Weight (g)",
      "weightGrossPlaceholder": "0.00",
      "caratNet": "Net Carat",
      "caratNetPlaceholder": "Ex: 24",
      "weightNet": "Net Weight (g)",
      "weightNetPlaceholder": "0.00",
      "calculations": {
        "title": "Automatic Calculations",
        "lossRate": "Loss Rate",
        "yieldRate": "Yield Rate",
        "realValue": "Real Value (estimated)",
        "weightLost": "Weight lost:",
        "marginImpact": "Margin impact:",
        "basedOnNet": "Based on net weight",
        "netOverGross": "Net weight / Gross weight",
        "grossToNet": "{gross}g → {net}g"
      },
      "partner": "Partner (optional)",
      "partnerPlaceholder": "Partner name"
    },
    "submit": "REGISTER",
    "success": "Transaction registered successfully!",
    "error": "Error registering transaction"
  },
  "positions": {
    "title": "Open Positions",
    "summary": {
      "weightedAvgPrice": "Weighted Average Price",
      "latentPnL": "Latent PnL",
      "totalExposure": "Total Exposure",
      "totalQuantity": "Total Quantity"
    },
    "filters": {
      "counter": "Counter",
      "all": "All",
      "type": "Type",
      "allTypes": "All",
      "raw": "Raw",
      "refined": "Refined"
    },
    "table": {
      "txNumber": "TX Number",
      "buyDate": "Buy Date",
      "buyPrice": "Buy Price",
      "quantity": "Quantity",
      "currentPrice": "Current Price",
      "latentPnL": "Latent PnL",
      "counter": "Counter",
      "type": "Type",
      "carat": "Carat"
    },
    "loading": "Loading positions...",
    "noPositions": "No open positions",
    "export": {
      "pdf": "Export PDF",
      "excel": "Export Excel",
      "title": "Open Positions",
      "exported": "Exported on:",
      "globalSummary": "Global Summary",
      "weightedAvgPrice": "Weighted Average Price:",
      "latentPnL": "Total Latent PnL:",
      "totalExposure": "Total Exposure:",
      "totalQuantity": "Total Quantity:",
      "headers": {
        "txNumber": "TX Num",
        "date": "Date",
        "buyPrice": "Buy Price",
        "quantity": "Quantity",
        "currentPrice": "Current Price",
        "latentPnL": "Latent PnL",
        "counter": "Counter",
        "type": "Type",
        "carat": "Carat"
      },
      "total": "Total: {count} open position(s)",
      "summary": "SUMMARY"
    }
  },
  "stock": {
    "title": "Physical Stock",
    "bamako": "Bamako Stock",
    "dubai": "Dubai Stock",
    "raw": "Raw",
    "refined": "Refined",
    "theoretical": "Theoretical:",
    "real": "Real:",
    "alert": "⚠️ Alert: Difference of {percent}%",
    "totalConsolidated": "Total Consolidated Stock",
    "totalRaw": "Total Raw",
    "totalRefined": "Total Refined",
    "update": "Update Real Stock",
    "updateModal": {
      "title": "Update Real Stock",
      "counter": "Counter",
      "type": "Type",
      "realStock": "Real Stock (g)",
      "realStockPlaceholder": "0.000",
      "save": "Save",
      "cancel": "Cancel"
    },
    "success": "Stock updated successfully",
    "error": "Error updating stock",
    "loading": "Loading stock...",
    "loadingSubtitle": "Retrieving data",
    "export": {
      "pdf": "Export PDF",
      "excel": "Export Excel",
      "title": "Physical Stock Status",
      "location": "Location",
      "type": "Type",
      "theoretical": "Theoretical Stock (g)",
      "real": "Real Stock (g)",
      "difference": "Difference (g)",
      "differencePercent": "Difference (%)"
    }
  },
  "margins": {
    "title": "Margins and Profits",
    "filters": {
      "period": "Period",
      "currency": "Currency Display",
      "currencyOptions": {
        "usd": "USD only",
        "aed": "AED only",
        "both": "USD and AED"
      }
    },
    "summary": {
      "totalBought": "Total Bought ({period})",
      "totalSold": "Total Sold ({period})",
      "realizedMargin": "Realized Margin",
      "netProfit": "Net Profit"
    },
    "chart": {
      "title": "Monthly Evolution",
      "subtitle": "Buy, Sell and Profit Comparison",
      "noData": "No data available",
      "noDataSubtitle": "Data will appear after your first transactions",
      "labels": {
        "buy": "Buy",
        "sell": "Sell",
        "profit": "Profit"
      }
    },
    "export": {
      "pdf": "Export Report (PDF)",
      "excel": "Export Data (Excel)",
      "title": "Margins and Profits Report",
      "totalBought": "Total Bought:",
      "totalSold": "Total Sold:",
      "realizedMargin": "Realized Margin:",
      "netProfit": "Net Profit:"
    },
    "loading": "Loading margins...",
    "loadingSubtitle": "Calculating"
  },
  "reports": {
    "title": "Reports & Analytics",
    "subtitle": "Detailed analysis of your performance and data",
    "types": {
      "overview": "Overview",
      "transactions": "Transactions",
      "margins": "Margins",
      "positions": "Positions"
    },
    "filters": {
      "title": "Filters",
      "startDate": "Start date",
      "endDate": "End date",
      "location": "Location",
      "allLocations": "All",
      "type": "Type",
      "allTypes": "All"
    },
    "export": {
      "pdf": "Export to PDF",
      "excel": "Export to Excel"
    },
    "overview": {
      "totalTransactions": "Total Transactions",
      "totalVolume": "Total Volume",
      "totalProfit": "Total Profit",
      "avgMargin": "Average Margin",
      "byDay": "Transactions by Day",
      "byType": "Transactions by Type",
      "byLocation": "Transactions by Location",
      "profitTrend": "Profit Trend"
    },
    "margins": {
      "title": "Margins Evolution",
      "buy": "Buy",
      "sell": "Sell",
      "profit": "Profit"
    },
    "positions": {
      "title": "Positions by Location",
      "quantity": "Quantity (g)",
      "exposure": "Exposure ($)"
    },
    "exportPdf": {
      "title": "Advanced Analytics Report",
      "period": "Period:",
      "exported": "Exported on:",
      "overview": "Overview",
      "totalTransactions": "Total Transactions:",
      "totalVolume": "Total Volume:",
      "totalProfit": "Total Profit:",
      "avgMargin": "Average Margin:",
      "byType": "Transactions by Type",
      "type": "Type",
      "count": "Count"
    },
    "loading": "Loading report..."
  },
  "admin": {
    "title": "Administration",
    "subtitle": "Interface reserved for super administrator",
    "connectedAs": "Connected as:",
    "tabs": {
      "partners": "Partners",
      "users": "Users"
    },
    "partners": {
      "add": "NEW PARTNER",
      "table": {
        "name": "Name",
        "email": "Email",
        "phone": "Phone",
        "company": "Company",
        "location": "Location",
        "status": "Status",
        "actions": "Actions"
      },
      "noPartners": "No partners registered",
      "modal": {
        "add": "Add a Partner",
        "edit": "Edit Partner",
        "fullName": "Full name *",
        "email": "Email *",
        "phone": "Phone",
        "company": "Company",
        "location": "Location *",
        "status": "Status *",
        "notes": "Notes",
        "addButton": "Add",
        "saveButton": "Save"
      },
      "deleteConfirm": "Are you sure you want to delete this partner?",
      "success": {
        "add": "Partner added successfully!",
        "edit": "Partner modified successfully!",
        "delete": "Partner deleted successfully!"
      }
    },
    "users": {
      "add": "NEW USER",
      "table": {
        "username": "Username",
        "email": "Email",
        "fullName": "Full name",
        "role": "Role",
        "permissions": "Permissions",
        "status": "Status",
        "actions": "Actions"
      },
      "noUsers": "No users registered",
      "noUsersSubtitle": "Users will be created via the backend API",
      "roles": {
        "admin": "Administrator",
        "user": "User",
        "viewer": "Viewer"
      },
      "permissions": {
        "read": "Read",
        "create": "Create",
        "update": "Update",
        "delete": "Delete"
      },
      "modal": {
        "add": "Create a User",
        "edit": "Edit User",
        "username": "Username *",
        "email": "Email *",
        "password": "Password",
        "passwordEdit": "Password (leave empty to not change)",
        "fullName": "Full name",
        "role": "Role *",
        "status": "Status *",
        "permissions": "Permissions",
        "createButton": "Create",
        "saveButton": "Save"
      },
      "deleteConfirm": "Are you sure you want to delete this user? This action is irreversible.",
      "success": {
        "add": "User created successfully!",
        "edit": "User modified successfully!",
        "delete": "User deleted successfully!",
        "toggle": "User {status} successfully!"
      },
      "toggle": {
        "deactivated": "deactivated",
        "activated": "activated"
      },
      "passwordMinLength": "Password must contain at least 6 characters"
    },
    "loading": "Loading...",
    "error": "Error",
    "success": "Success",
    "backup": {
      "manual": "Manual Backup",
      "creating": "Creating..."
    }
  },
  "profile": {
    "title": "My Profile",
    "tabs": {
      "info": "Personal Information",
      "password": "Password",
      "preferences": "Preferences",
      "history": "History"
    },
    "info": {
      "fullName": "Full name",
      "email": "Email",
      "phone": "Phone",
      "company": "Company",
      "role": "Role",
      "save": "Save changes",
      "saving": "Saving...",
      "success": "Profile updated successfully!"
    },
    "password": {
      "current": "Current password",
      "new": "New password",
      "confirm": "Confirm new password",
      "minLength": "Minimum 8 characters",
      "change": "Change password",
      "changing": "Changing...",
      "success": "Password changed successfully!",
      "error": {
        "mismatch": "Passwords do not match",
        "minLength": "Password must contain at least 8 characters"
      }
    },
    "preferences": {
      "theme": "Theme",
      "light": "Light",
      "dark": "Dark",
      "language": "Language",
      "currency": "Default currency",
      "notifications": "Notifications",
      "email": "Email notifications",
      "push": "Push notifications",
      "sms": "SMS notifications",
      "save": "Save preferences",
      "success": "Preferences saved successfully!"
    },
    "history": {
      "title": "Connection History",
      "noHistory": "No connection history available",
      "table": {
        "date": "Date",
        "ip": "IP",
        "location": "Location",
        "device": "Device",
        "status": "Status"
      },
      "status": {
        "success": "Success",
        "failure": "Failure"
      }
    },
    "error": "Error updating profile"
  },
  "alerts": {
    "title": "Alert Settings",
    "goldPrice": {
      "title": "Gold Price Alerts",
      "description": "Receive notifications when the gold price exceeds your thresholds",
      "minThreshold": "Minimum Threshold (USD/oz)",
      "minPlaceholder": "2500",
      "minHelp": "Alert if price < minimum threshold",
      "maxThreshold": "Maximum Threshold (USD/oz)",
      "maxPlaceholder": "2800",
      "maxHelp": "Alert if price > maximum threshold"
    },
    "stock": {
      "title": "Stock Difference Alerts",
      "description": "Receive notifications when theoretical stock differs from real stock"
    },
    "margin": {
      "title": "Margin & Profit Alerts",
      "description": "Receive notifications when margin is below minimum threshold",
      "threshold": "Minimum Margin Threshold (%)",
      "thresholdPlaceholder": "5",
      "thresholdHelp": "Alert if margin < minimum threshold"
    },
    "save": "Save Settings",
    "success": {
      "title": "Settings saved",
      "message": "Your alert settings have been saved successfully."
    }
  },
  "footer": {
    "company": "Golden Mali SARL",
    "description": "SaaS platform for professional management of gold and precious metals flows.",
    "legal": "Legal Notice",
    "legalItems": {
      "legal": "Legal Notice (coming soon)",
      "privacy": "Privacy Policy (coming soon)",
      "terms": "Terms & Conditions (coming soon)"
    },
    "contact": "Contact",
    "contactDescription": "For any questions or support, contact us.",
    "copyright": "© {{year}} Golden Mali SARL. All rights reserved.",
    "developer": "SaaS Platform created by",
    "developerLink": "Créatif-web"
  },
  "accessDenied": {
    "title": "Access Denied",
    "message": "You do not have the necessary permissions to access this page.",
    "back": "Back to home"
  },
  "financialFlows": {
    "export": {
      "usdPurchases": "USD Purchases",
      "beneficiaryPayments": "Beneficiary Payments",
      "transferRequests": "Transfer Requests",
      "goldCommissions": "Gold Commissions",
      "exportedOn": "Exported on",
      "totalRecords": "Total",
      "records": "record(s)",
      "headers": {
        "reference": "Ref.",
        "partner": "Partner",
        "beneficiary": "Beneficiary",
        "client": "Client",
        "cfa": "CFA",
        "usd": "USD",
        "aed": "AED",
        "amountAed": "Amount AED",
        "status": "Status",
        "period": "Period",
        "volume": "Volume",
        "commission": "Commission"
      },
      "status": {
        "paid": "paid",
        "pending_payment": "pending",
        "cancelled": "cancelled",
        "pending": "pending",
        "partner_paid": "partner paid",
        "swift_received": "SWIFT received",
        "recipient_confirmed": "recipient confirmed",
        "closed": "closed"
      }
    }
  },
  "swift": {
    "title": "SWIFT Payments Management",
    "subtitle": "TT (Telegraphic Transfers) management and tracking system",
    "newPayment": "New SWIFT Payment",
    "list": "Payments List",
    "create": "Create Payment",
    "details": "Payment Details",
    "reference": "SWIFT Reference",
    "status": "Status",
    "amount": "Amount",
    "currency": "Currency",
    "client": "Client",
    "beneficiary": "Beneficiary",
    "beneficiaryName": "Beneficiary Name",
    "beneficiaryAccount": "Beneficiary Account",
    "beneficiaryBank": "Beneficiary Bank",
    "beneficiaryBankSwift": "Bank SWIFT Code",
    "beneficiaryAddress": "Beneficiary Address",
    "sender": "Sender",
    "senderName": "Sender Name",
    "senderAccount": "Sender Account",
    "senderBank": "Sender Bank",
    "senderBankSwift": "Sender Bank SWIFT Code",
    "transaction": "Associated Transaction",
    "partner": "Partner",
    "documents": "Documents",
    "history": "History",
    "actions": "Actions",
    "createButton": "Create Payment",
    "cancelButton": "Cancel",
    "saveButton": "Save",
    "uploadDocument": "Add Document",
    "documentType": "Document Type",
    "documentDescription": "Description",
    "selectFile": "Select file",
    "noDocuments": "No documents",
    "noHistory": "No history",
    "statuses": {
      "pending": "Request created",
      "submitted": "Submitted",
      "sent_to_intermediary": "Sent to intermediary",
      "processing": "Transfer in progress",
      "swift_received": "SWIFT received",
      "completed": "Payment confirmed",
      "rejected": "Rejected",
      "cancelled": "Cancelled"
    },
    "documentTypes": {
      "invoice": "Invoice",
      "contract": "Contract",
      "receipt": "Receipt",
      "swift_confirmation": "SWIFT Confirmation",
      "other": "Other"
    },
    "actionsMenu": {
      "sendToIntermediary": "Send to intermediary",
      "markProcessing": "Mark as transfer in progress",
      "markSwiftReceived": "Mark SWIFT received",
      "complete": "Confirm payment",
      "reject": "Reject",
      "viewDetails": "View details",
      "downloadDocument": "Download",
      "deleteDocument": "Delete"
    },
    "form": {
      "required": "This field is required",
      "invalidAmount": "Amount must be greater than 0",
      "invalidSwiftCode": "Invalid SWIFT code (format: 8 or 11 characters)",
      "success": "SWIFT payment created successfully",
      "error": "Error creating payment"
    },
    "filters": {
      "all": "All",
      "status": "Filter by status",
      "client": "Filter by client",
      "partner": "Filter by partner"
    },
    "table": {
      "reference": "Reference",
      "client": "Client",
      "beneficiary": "Beneficiary",
      "amount": "Amount",
      "status": "Status",
      "createdAt": "Creation date",
      "actions": "Actions",
      "noPayments": "No SWIFT payments"
    },
    "modal": {
      "confirmReject": "Are you sure you want to reject this payment?",
      "rejectReason": "Rejection reason",
      "confirmComplete": "Confirm payment",
      "bankReference": "Bank reference",
      "processingNotes": "Processing notes"
    },
    "success": {
      "created": "SWIFT payment created successfully",
      "sentToIntermediary": "Payment sent to intermediary successfully",
      "markedProcessing": "Payment marked as in progress",
      "markedSwiftReceived": "Payment marked as SWIFT received",
      "completed": "Payment confirmed successfully",
      "rejected": "Payment rejected",
      "documentUploaded": "Document uploaded successfully",
      "documentDeleted": "Document deleted successfully"
    },
    "error": {
      "load": "Error loading payments",
      "create": "Error creating",
      "update": "Error updating",
      "upload": "Error uploading document",
      "delete": "Error deleting"
    }
  },
  "cookies": {
    "title": "Cookie Management",
    "subtitle": "We use cookies to improve your experience",
    "description": "This platform uses cookies to ensure the proper functioning of the site, remember your preferences, and improve your user experience. By continuing to use this platform, you accept the use of cookies in accordance with our privacy policy.",
    "types": {
      "title": "Types of cookies used",
      "essential": {
        "title": "Essential cookies",
        "description": "Necessary for the platform to function (authentication, security, language preferences)"
      },
      "functional": {
        "title": "Functional cookies",
        "description": "Enhance your experience (remembering preferences, data synchronization)"
      },
      "analytics": {
        "title": "Analytics cookies",
        "description": "Help us understand how you use the platform (anonymous statistics)"
      }
    },
    "moreInfo": "For more information, please consult our privacy policy.",
    "accept": "I Accept",
    "reject": "I Reject"
  }
};

export default en;
